import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "unknown",
  "use": "unknown-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"unknown\"><path d=\"M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z\" fill=\"#e2e5e7\" /><path d=\"M384 128h96L352 0v96c0 17.6 14.4 32 32 32z\" fill=\"#b0b7bd\" /><path fill=\"#cad1d8\" d=\"M480 224l-96-96h96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/unknown.svg
// module id = 5iXr
// module chunks = 1